<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-0 px-4 layout row wrap">
          <v-btn class="primary ma-0" @click='$router.push({ name: "corporationCreate" })'>{{$lang.actions.createCorporation}}</v-btn>
          <v-checkbox
            color="primary"
            class="ml-3 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
           />
          <v-spacer />
          <v-text-field
            class="min-w max-w"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="showActive ? activeCorporations : allCorporations"
          :search="search"
          :loading="allCorporations.length === 0"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.name }}</td>
            <td>{{ formatDate(props.item.createdOn) }}</td>
            <td>{{ props.item.status }}</td>
            <td class="min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'corporationEdit', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data() {
      return {
        err: '',
        search: '',
        headers: [
          {text: this.$lang.labels.name, value: 'name', align: 'left',},
          {text: this.$lang.labels.created, value: 'createdOn', align: 'left',},
          {text: this.$lang.labels.status, value: 'status', align: 'left',},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false,},
        ],
        allCorporations: [],
        showActive: true,
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      changeStatus(corporation) {
        const action = corporation.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`corporation/${action}/${corporation.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(corporation, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      }
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
      activeCorporations() {
        const corporations = this.allCorporations;
        const activeCorporations = [];
        for (let i=0; corporations.length > i; i++) {
          if (corporations[i].status === 'active') {
            activeCorporations.push(corporations[i]);
          }
        }
        return activeCorporations;
      },
    },
    created() {
      this.$http.get('corporation/getall')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.allCorporations = res.body.corporations;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    }
  };
</script>



// WEBPACK FOOTER //
// Corporations.vue?4b99954a